import './index.scss';
import {Card, Layout, message} from "antd";
import React, {useEffect} from "react";
import {useHistory} from "react-router-dom";
import {connect} from "react-redux";
import {
    getOrdersListAction,
    resetOrderInputsValues,
    updateOrderStateValues
} from "../../../store/actions/orders.action";
import BreadcrumbComponent from "../../../components/shared/breadcrumb/Breadcrumb";
import {OrderSummaryCard} from "../components/order-summary-card/index";
import {OrderProductCard} from "../components/order-product-card/index";

const CreateOrder = ({
   loading,
   error,
   success,
   updateOrderStateValues,
   selectedOrderId,
}) => {
    const navigate = useHistory();

    const viewOrder = () => {
        navigate.push(!selectedOrderId ? '/orders/new' : `/orders/${selectedOrderId}`);
    }

    const addProduct = () => {
        navigate.push(!selectedOrderId ? '/orders/new/add-product' : `/orders/${selectedOrderId}/add-product`);
    }

    const actionButtons = [{
        label: 'Add product to order',
        type: 'primary',
        onClick: addProduct,
    }, {
        label: 'View order',
        type: 'primary',
        onClick: viewOrder,
    }];
    // Show Success / Failure Message
    useEffect(() => {
        if (!loading) {
            if (error) {
                message.error(error).then(() => {
                    updateOrderStateValues({
                        error: '',
                    })
                });
            } else if (success) {
                message.success(success).then(() => {
                    updateOrderStateValues({
                        error: '',
                    })
                });
            }
        }
    }, [loading, error, success, updateOrderStateValues]);

    return (
        <Layout className='padding-8'>
            <div>
                <BreadcrumbComponent actionButtons={actionButtons} />
                <Card size="small" className='background-grey'>
                    <div className='add-product-page d-flx flx-d-clm gap-12'>
                        <div className='search-cont'>
                            <OrderSummaryCard />
                        </div>
                        <div className='search-result-cont d-flx gap-12'>
                            <OrderProductCard />
                        </div>
                    </div>
                </Card>
            </div>
        </Layout>
    )
}

const mapStateToProps = ({ ordersState }) => {
    const {
        orders, loading, error, success,
    } = ordersState;

    return {
        orders,
        loading,
        error,
        success,
    }
}

export default connect(mapStateToProps, {
    getOrdersListAction,
    updateOrderStateValues,
    resetOrderInputsValues,
})(CreateOrder);
